import { Container } from 'inversify';
import 'reflect-metadata';
import {
  ILocalStorageService,
  IBrowserService,
  ILoggerService,
  IUtilService,
  IOnboardingLookupService,
  INotificationService,
  IToastrService,
  IPopupService,
  IGlobalErrorHandlerService,
  IAPIService
} from '../services/interfaces';

import DITYPES from './di.types';
import LocalStorageService from '../services/local.storage.service';
import BrowserService from './../services/BrowserService';
import LoggerService from './../services/LoggerService';
import UtilService from './../services/UtilService';
import OnBoardingLookupService from '../services/OnboardingService';
import NotificationService from '../services/NotificationService';
import ToastrService from '../services/ToastrService';
import PopupService from '../services/PopupService';
import GlobalErrorHandlerService from '../services/GlobalErrorHandlerService'
import APIService from '../services/ApiService';

const DIContainer = new Container({ defaultScope: 'Singleton' });

DIContainer.bind<IBrowserService>(DITYPES.BrowserService).to(BrowserService);
DIContainer.bind<ILocalStorageService>(DITYPES.LocalstorageService).to(LocalStorageService);
DIContainer.bind<ILoggerService>(DITYPES.LoggerService).to(LoggerService);
DIContainer.bind<IUtilService>(DITYPES.UtilService).to(UtilService);
DIContainer.bind<IOnboardingLookupService>(DITYPES.OnboardingLookupService).to(OnBoardingLookupService);
DIContainer.bind<INotificationService>(DITYPES.NotificationService).to(NotificationService);
DIContainer.bind<IToastrService>(DITYPES.ToastrService).to(ToastrService);
DIContainer.bind<IPopupService>(DITYPES.PopupService).to(PopupService);
DIContainer.bind<IGlobalErrorHandlerService>(DITYPES.GlobalErrorHandlerService).to(GlobalErrorHandlerService);
DIContainer.bind<IAPIService>(DITYPES.ApiService).to(APIService);

export { DIContainer as default };
